import { createSlice } from "@reduxjs/toolkit";

const refundFilterSlice = createSlice({
  name: "refundFilter",
  initialState: {
    status: null,
    search: null,
  },
  reducers: {
    setRefundStatusFilter: (state, action) => {
      state.status = action.payload ?? null;
    },

    setRefundSearchFilter: (state, action) => {
      state.search = action.payload ?? null;
    },

    clearRefundSearchFilter: (state) => {
      state.search = null;
    },
  },
});

export const {
  setRefundStatusFilter,
  setRefundSearchFilter,
  clearRefundSearchFilter,
} = refundFilterSlice.actions;

export const selectRefundState = (state) => state.refundFilter;

export default refundFilterSlice.reducer;
